module.exports = __webpack_public_path__ + "static/2-layer3-e03a525ab55dd3519ee0a6093b13fee3.svg";